const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenbank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.95,7.95h-6.17c-.69,0-1.3.5-1.37,1.19-.11.94-.83,1.48-1.69,1.51-.94,0-1.69-.76-1.69-1.69s.76-1.69,1.69-1.69c.61,0,1.15.32,1.44.83.04.04.07.04.11,0,.18-.22.4-.4.65-.5.04,0,.04-.07.04-.11-.47-.72-1.3-1.19-2.24-1.19-1.48,0-2.67,1.19-2.7,2.7,0,1.48,1.19,2.7,2.7,2.7,1.37-.04,2.52-.94,2.67-2.38.04-.18.18-.32.4-.32h5.27v.72c0,.4-.11.97-.61.97s-.61-.58-.61-.97v-.22s-.04-.07-.07-.07h-.87s-.07.04-.07.07v.18c0,.4-.11.97-.61.97s-.61-.58-.61-.97v-.18s-.04-.07-.07-.07h-.87s-.07.04-.07.07v.18c0,.97.54,1.95,1.59,1.95.43,0,.83-.18,1.08-.5.29.32.65.5,1.08.5,1.08,0,1.59-1.01,1.59-1.95v-1.66c.14-.04.11-.07.04-.07",
    style: {
      fill: "#ff004d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenbank);
export default __webpack_public_path__ + "static/media/openbank.b4b9578633e639e5a8137f2fbd4c61f1.svg";
export { ForwardRef as ReactComponent };